<div class='DeletedMeetings'>
  <div class='Breadcrumbs mb-5'>
    <div class='Breadcrumbs-items'>
      <a [routerLink]="['/messages']">
        <mat-icon class='Breadcrumbs-icon back'>keyboard_backspace</mat-icon>
      </a>
      <a
        [routerLink]="['/messages']"
        class='Breadcrumbs-item first'
      >Inbox</a
      >
      <mat-icon class='Breadcrumbs-icon'>chevron_right</mat-icon>
      <span class='Breadcrumbs-item'>Deleted meetings</span>
    </div>
  </div>
  <app-table
    (data)='onData($event)'
    *ngIf='tableReady'
    [columns]='tableColumns'
    [dataSourceParams]='tableDataSourceParams'
    [dataSource]='dataSource'
    [filterGroups]='tableFilterGroups'
    [filters]='tableFilters'
    [rowClass]='rowClass'
    [useRouteNavigation]='false'></app-table>
</div>
